import { useContext, useEffect } from "react";
import "./CorporateMemberPage.scss";
import { Workflow, useTranslator, useNavigator } from "@sia/style-guide";
import { useState } from "react";
import { WizarContext, initialWizardFormState } from "contexts/WizardContext";

import Info from "./Info";
import CommunicationInfo from "./Communication";
import Summary from "./Summary";
import pgAdapter from "common/Adapters/PGAdapter/PGAdapter";
import MainAddress from "./MainAddress";
import Ahv from "./Ahv";
import SingleMembers from "./SinglesAddition";

const CorporateMemberPage = () => {
  const translate = useTranslator();
  const { state } = useContext(WizarContext);
  const singleMember = state.corporate.singleMember;
  const corporateInfo = state.corporate.corporateInfo;
  const mainAddress = state.corporate.mainAddress;
  const ahv = state.corporate.ahv;

  const [errors, setErrors] = useState(initialWizardFormState);

  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [shouldNavigateToNextStep, setShouldNavigateToNextStep] = useState(true);
  const [step, setStep] = useState(0);
  const navigate = useNavigator();

  const labels = {
    back: translate("wizard.form.single.button.back"),
    next: translate("wizard.form.single.button.next"),
    submit: translate("wizard.form.single.summary.button.label"),
    step: "Step",
    of: "Of",
  };

  const updateSingleMemberErrors = () => {
    let localShouldNavigateToNextStep = true;
    for (let property in singleMember) {
      if (singleMember[property] === "" || singleMember[property] === null || singleMember[property] === undefined) {
        localShouldNavigateToNextStep = false;
        setErrors((errorState) => ({
          ...errorState,
          corporate: {
            ...errorState.corporate,
            singleMember: { ...errorState.corporate.singleMember, [property]: translate("form.input.error.empty") },
          },
        }));
      }
    }
    setShouldNavigateToNextStep(localShouldNavigateToNextStep);
  };

  const updateInfoErrors = () => {
    const optionalProperties = ["extraName", "website"];
    let localShouldNavigateToNextStep = true;
    for (let property in corporateInfo) {
      if (
        (corporateInfo[property] === "" || corporateInfo[property] === null || corporateInfo[property] === undefined) &&
        !optionalProperties.includes(property)
      ) {
        localShouldNavigateToNextStep = false;
        setErrors((errorState) => ({
          ...errorState,
          corporate: {
            ...errorState.corporate,
            corporateInfo: { ...errorState.corporate.corporateInfo, [property]: translate("form.input.error.empty") },
          },
        }));
      }
    }
    setShouldNavigateToNextStep(localShouldNavigateToNextStep);
  };

  const updateMainAddressErrors = () => {
    const optionalProperties = ["streetTwo"];
    let localShouldNavigateToNextStep = true;
    for (let property in mainAddress) {
      if ((mainAddress[property] === "" || mainAddress[property] === null) && !optionalProperties.includes(property)) {
        localShouldNavigateToNextStep = false;
        setErrors((errorState) => ({
          ...errorState,
          corporate: {
            ...errorState.corporate,
            mainAddress: { ...errorState.corporate.mainAddress, [property]: translate("form.input.error.empty") },
          },
        }));
      }
    }
    setShouldNavigateToNextStep(localShouldNavigateToNextStep);
  };

  const updateAhvErrors = () => {
    const optionalProperties = ["streetTwo"];
    let localShouldNavigateToNextStep = true;
    for (let property in ahv) {
      if ((ahv[property] === "" || ahv[property] === null) && !optionalProperties.includes(property)) {
        localShouldNavigateToNextStep = false;
        setErrors((errorState) => ({
          ...errorState,
          corporate: {
            ...errorState.corporate,
            ahv: { ...errorState.corporate.ahv, [property]: translate("form.input.error.empty") },
          },
        }));
      }
    }
    setShouldNavigateToNextStep(localShouldNavigateToNextStep);
  };

  const checkForFormsError = () => {
    if (currentStepIndex === 0) {
      updateSingleMemberErrors();
    }
    if (currentStepIndex === 1) {
      updateInfoErrors();
    }
    if (currentStepIndex === 2) {
      updateMainAddressErrors();
    }
    if (currentStepIndex === 3) {
      updateAhvErrors();
    }
  };

  const steps = [
    {
      label: translate("wizard.form.corporate.singleChoice.label"),
      content: <SingleMembers errors={errors} setErrors={setErrors} />,
    },
    {
      label: translate("wizard.form.corporate.info.label"),
      content: <Info errors={errors} setErrors={setErrors} />,
    },
    { label: translate("wizard.form.corporate.mainAddress.label"), content: <MainAddress errors={errors} setErrors={setErrors} /> },
    { label: translate("wizard.form.corporate.ahv.label"), content: <Ahv errors={errors} setErrors={setErrors} /> },
    { label: translate("wizard.form.corporate.communication.label"), content: <CommunicationInfo errors={errors} setErrors={setErrors} /> },
    { label: translate("wizard.form.corporate.summary.label"), content: <Summary /> },
  ];

  useEffect(() => {
    if (shouldNavigateToNextStep) {
      setCurrentStepIndex(step);
    }
    if (step < currentStepIndex && !shouldNavigateToNextStep) {
      setShouldNavigateToNextStep(true);
    }
  }, [step, shouldNavigateToNextStep, currentStepIndex]);

  function submitForm() {
    let body = { form_data: { ...state.corporate, is_corporate: true } };
    pgAdapter.request("POST", "member_subscription/register_single", body, (data) => {
      if (data.status === 200) {
        navigate("");
      } else {
        // NOW WHAT?
      }
    });
  }

  return (
    <div className="corporate-member-page">
      <h3 className="corporate-member-page__heading productive-heading-04 sia-text-12 sia-margin-06-top sia-margin-05-bottom">
        {translate("wizard.corporate.title")}
      </h3>
      <Workflow
        steps={steps}
        labels={labels}
        slimContent={true}
        currentStepIndex={currentStepIndex}
        onNavigate={(newStepIndex) => {
          checkForFormsError();
          setStep(newStepIndex);
        }}
        onSubmit={() => submitForm()}
      />
    </div>
  );
};

export default CorporateMemberPage;
